import React, { useEffect } from 'react';
import './index.css';
import { Box, CircularProgress, CssBaseline, Grid, ThemeProvider } from '@mui/material';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { useNavigate, useLocation, BrowserRouter } from 'react-router-dom';
import { persistor, store } from './Slice/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './components/Login.jsx';
import ProjectRoutes from './components/router/index.js';
import theme from './theme.js';
import Header from './components/pages/Layout/Header.jsx';

function AppContent() {
  const vLoginData = useSelector((state) => state.user);
  const vKern = useSelector((state) => state.user.kern);
  const navigate = useNavigate();
  const location = useLocation();

useEffect(() => {
  const allowedPaths = [
    '/home',
    '/',
    '/project',
    '/todayActivity',
    '/lead-details',
    '/acitivitySummary',
    '/software-management',
    '/heatMap',
    '/client-visit',
    '/AMC-Followup',
    '/preview-pdf',
    '/lead-Stage',
    '/softwareUpdate',
    '/softwareUpdateTrans',
    '/expenseBooking',
    '/bookingVerify',
    '/bookingConfirmed',
    '/dailyReport'
  ];
 if (vLoginData?.userCd) {
    if (!allowedPaths.includes(location.pathname)) {
      navigate('/myWork');
    }
  } else {
    navigate('/');
  }
}, []); // ← empty dependency array: run only once on mount


  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const os = /iPad|iPhone|iPod/.test(userAgent)
      ? 'iOS'
      : /android/i.test(userAgent)
      ? 'Android'
      : 'Other';

    document.body.classList.add(os); // Add 'iOS' or 'Android' to <body>
  }, []);

  return (
    <Box
      backgroundColor={theme.palette.primary.surface}
      sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <CssBaseline />
      {vLoginData?.userCd ? (
        <Grid container>
            <Grid item xs={12}>
              <Header />
            </Grid>
          <Grid item xs={12}>
            <ProjectRoutes />
          </Grid>
        </Grid>
      ) : (
        <Login />
      )}
    </Box>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ToastContainer />
            <div id="loader" style={{ display: 'none' }} className="mui-spinner">
              <CircularProgress
                size={60}
                sx={{
                  animationDuration: '500ms'
                }}
              />
            </div>
            <AppContent />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
export default App;
